/**
 * @generated SignedSource<<a61b4628445091744c4604c5d762e65e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RequestedBudgetProjectUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectTPayload",
        "kind": "LinkedField",
        "name": "updateProjectTByProjectId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectT",
            "kind": "LinkedField",
            "name": "projectT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RequestedBudgetProjectUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectTPayload",
        "kind": "LinkedField",
        "name": "updateProjectTByProjectId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectT",
            "kind": "LinkedField",
            "name": "projectT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5e517933049e36226c88aa68e14ea3c8",
    "id": null,
    "metadata": {},
    "name": "RequestedBudgetProjectUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation RequestedBudgetProjectUpdateMutation(\n  $input: UpdateProjectTByProjectIdInput!\n) {\n  updateProjectTByProjectId(input: $input) {\n    projectT {\n      projectId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "e6cc359b62d067dda82ee56cd9b26e95";

module.exports = node;
